export default "__VITE_ASSET__PGC9fxU5__"